var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"collapsible":"","collapsed":"","help-collapsed":_vm.sectionHelp,"title":_vm.sectionTitle}},[_c('Details',{attrs:{"debtPayData":_vm.debtPayData}}),_c('ReceiveList',{attrs:{"debtPayData":_vm.debtPayData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }